<template>
    <div class="activate-form">
        <div>
            <p class="activate-form__description">
                {{  $t('Two-step verification adds an extra layer of security to your account, but it is optional. You can activate it now or set it up later from the security section.') }}
            </p>
            <p class="activate-form__question">
                {{ $t('Do you want to activate two-step verification?') }}
            </p>
            <div class="activate-form__actions">
                <ui-button @click="activeNow" variant="primary" :loading="loading" :disabled="later" class="w-100">
                    {{ $t('Activate now') }}
                </ui-button>
                <ui-button @click="activeLater"  :disabled="loading" :loading="later" variant="secondary" class="w-100">
                    {{ $t('Activate later') }}
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
import UiButton from '@/components/ui/buttons/Button.vue';

export default {
    name: 'ActivateForm',
    components: { UiButton },
    data() {
        return {
            loading: false,
            later: false,
        }
    },
    methods: {
        activeNow() {
            this.loading = true;
            this.$emit('showQRCode', true);
        },
        activeLater() {
            this.later = true;
            this.$emit('showQRCode', false);
        }
    }
}
</script>

<style lang="scss">
.activate-form {
    
    &__description {
        font-size: 16px;
        line-height: 19.5px;
        font-weight: 400;
        color: $accounts-secondary-600;
        margin-bottom: 32px !important;
        text-align: left !important;
    }

    &__question {
        font-size: 20px;
        margin-bottom: 24px !important;

        @media(max-width: 768px) {
            font-size: 18px;
        }
    }

    &__actions {
        display: flex;
        justify-content: center;
        gap: 16px;

        @media(max-width: 768px) {
            flex-direction: column;
            padding: 0 16px;
        }
    }
}
</style>